export const formatOtpCountdown = (totalSeconds: number): string => {
  const seconds = Math.max(0, Math.ceil(totalSeconds))
  if (seconds <= 60) return `${seconds} segundos`

  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = String(seconds % 60).padStart(2, '0')
  return `${minutes} min ${remainingSeconds} s`
}
